import { Apple, Play } from "lucide-react";

const STORES = [
  {
    id: "apple",
    href: "https://apps.apple.com/us/app/tripsee-io/id6746733762",
    Icon: Apple,
    top: "Download on the",
    bottom: "App Store",
    iconClass: "text-white fill-white",
  },
  {
    id: "google",
    href: "https://play.google.com/store/apps/details?id=io.tripsee",
    Icon: Play,
    top: "Get it on",
    bottom: "Google Play",
    iconClass: "text-primary fill-primary",
  },
];

export default function StoreBadges({ testIdPrefix = "store", className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row items-center gap-4 ${className}`}>
      {STORES.map((s) => (
        <a
          key={s.id}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testIdPrefix}-badge-${s.id}`}
          className="group inline-flex items-center gap-3.5 rounded-2xl border border-white/15 bg-[#101315] px-6 py-3.5 transition-all duration-200 hover:border-primary/50 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/10"
        >
          <s.Icon size={30} strokeWidth={1.5} className={s.iconClass} />
          <span className="text-left leading-tight">
            <span className="block text-[10px] font-medium uppercase tracking-widest text-slate-400">
              {s.top}
            </span>
            <span className="block text-lg font-semibold text-white">{s.bottom}</span>
          </span>
        </a>
      ))}
    </div>
  );
}
